import { NgRedux } from "@angular-redux/store";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,

} from "@angular/core";
import { CoachService } from "app/core/services/coach.service";
import { PartnerService } from "app/core/services/partner.service";
import { StudentService } from "app/core/services/student.service";
import { IAppState } from "app/redux/store";
import { AuthService } from "app/core/services/auth.service";
import { async, of } from "rxjs";
import { map } from "rxjs/operators";
import { MemberFilter } from "./member-filter-new.state";
import * as _ from "lodash";
import { AppService } from "app/core/services/app.service";
import { loadManagerPermissionSuccess } from "app/redux/actions/dashboard.actions";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";
import { SHIFT_TIMES } from "app/helpers/constants";
import { getLastActivities, getMemberAgeRange } from "app/helpers/date";
import moment from 'moment-timezone'
import { LeadService } from "app/core/services/lead.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { AdminSettingsService } from "app/core/services/admin-settings.service";
import { NotificationService } from "app/core/services/notification.service";

@Component({
  selector: "member-filters-new",
  templateUrl: "./member-filters-new.component.html",
  styleUrls: ["./member-filters-new.component.scss"],
})
export class MemberFiltersNewComponent implements OnInit {
  @Input() disableShadow = false;
  @Input() disablePartnersWellNessSurvey = false;
  @Input() EnableDateRange = false;
  @Input() leadSource = false;
  @Input() isFilterLoading = false;
  startMaxDate;
  endMinDate;

  dateHelperButtonState = {
    '1d': false,
    '7d': false,
    'start of school year': false
  };

  filterOptions = {
    status$: null,
    partner$: null,
    coachTeam: null,
    shiftTime: null,
    shiftDay: null,
    wellnessSurveyGroup: null,
    raceAndEthnicity: null,
    gender: null,
    orientation: null,
    city: null,
    name: null,
    ages: null,
    show: 'all-time',
    startDate: null,
    endDate: null,
    engagementStatusOptions: null,
    leadSource$: null,
    lastActivity: null,
  };

  statusSelectedAll = false;
  partnerSelectedAll = false;
  coachTeamSelectedAll = false;
  shiftTimeSelectedAll = false;
  shiftDaySelectedAll = false;
  wellnessSurveyGroupSelectedAll = false;
  raceAndEthnicitySelectedAll = false;
  genderSelectedAll = false;
  orientationSelectedAll = false;
  citySelectedAll = false;
  wellnessSurveyGroupsNoData = false;
  agesSelectedAll = false;
  leadSourceSelectedAll = false;

  //dashboard filter
  @ViewChild("statusFilter") statusFilter: MatSelect;
  @ViewChild("partnerFilter") partnerFilter: MatSelect;
  @ViewChild("coachTeamFilter") coachTeamFilter: MatSelect;
  @ViewChild("shiftTimeFilter") shiftTimeFilter: MatSelect;
  @ViewChild("shiftDayFilter") shiftDayFilter: MatSelect;
  @ViewChild("wellnessSurveyGroupFilter") wellnessSurveyGroupFilter: MatSelect;
  @ViewChild("raceAndEthnicityFilter") raceAndEthnicityFilter: MatSelect;
  @ViewChild("genderFilter") genderFilter: MatSelect;
  @ViewChild("orientationFilter") orientationFilter: MatSelect;
  @ViewChild("cityFilter") cityFilter: MatSelect;
  @ViewChild("agesFilter") agesFilter: MatSelect;
  @ViewChild("engagementStatusFilter") engagementStatusFilter: MatSelect;
  @ViewChild("leadSourceFilter") leadSourceFilter: MatSelect;
  memberFilter = MemberFilter;
  memberFilterCopy = { ...this.memberFilter }; // does not hold reference of memberfilter so it wont mutate it
  @Output() onMemberFilterUpdate = new EventEmitter<object>();
  @Output() memberFilterData$ = new EventEmitter<object>();
  @Output() onFilterLoading = new EventEmitter<boolean>();
  shiftTimes = SHIFT_TIMES;
  isCollapsed = false;
  shiftDays = [
    {
      label: "Monday",
      value: "1",
    },
    {
      label: "Tuesday",
      value: "2",
    },
    {
      label: "Wednesday",
      value: "3",
    },
    {
      label: "Thursday",
      value: "4",
    },
    {
      label: "Friday",
      value: "5",
    },
    {
      label: "Saturday",
      value: "6",
    },
    {
      label: "Sunday",
      value: "7",
    },
  ];

  engagementStatusOptions = [
    {
      displayTitle: "ACTIVE ENGAGED",
      value: "ACTIVE_ENGAGED",
    },
    {
      displayTitle: "NOT YET ENGAGED",
      value: "NOT_YET_ENGAGED",
    },
  ];

  WellnessSurveyData = [
    {
      label: "SWEMWBS + NO SIAOS",
      value: "1",
    },
    {
      label: "SWEMWBS + PHQ9",
      value: "2",
    },
    {
      label: "SWEMWBS + GAD7",
      value: "3",
    },
    {
      label: "SWEMWBS + PCLC6",
      value: "4",
    },
    {
      label: "AmeriHealth SWEMWBS",
      value: "5",
    },
    {
      label: "Opted Out",
      value: "6",
    },
    {
      label: "1st-time SWEMWBS",
      value: "7",
    },
  ];

  memberFilterOptions = {
    coachTeam: [],
    city: [],
  };
  managerCoachView = true;
  partnerView = true;
  shiftDayView = true;
  shiftTimeView = true;
  currentUser;
  wellnessSurveyGroups = [];
  todayDate = new Date();
  constructor(
    private auth: AuthService,
    private studentService: StudentService,
    private partnerService: PartnerService,
    private coachService: CoachService,
    private store: NgRedux<IAppState>,
    private app: AppService,
    private leadService: LeadService,
    private adminService: AdminSettingsService,
    private notification: NotificationService
  ) { }

  ngOnInit() {
    this.auth.getCurrentUser().subscribe((user) => {
      this.currentUser = user;
    });

    if (this.currentUser.type == "Manager") {
      this.coachService
        .getManagerPermission(this.currentUser._data._id)
        .subscribe((manager) => {
          this.store.dispatch(
            loadManagerPermissionSuccess(manager._permissions)
          );
          this.broadcastUpdate();
        });
    } else {
      this.broadcastUpdate();
    }
    // load data
    this.loadData();
  }

  async loadData() {
    try {
      // remove unnecessary call to getCoaches this introduce an overhead to load all coaches
      // this has been handled on the server
      // Get coaches
      // const allCoaches = await this.getCoaches();
      // this.coaches = allCoaches;
      const memfilter = await this.coachService.loadAssignedMemberFilters();
      // Get member filters
      this.memberFilterOptions = memfilter || {
        coachTeam: {},
        city: [],
      };

      this.loadFilterOptions();
    } catch (error) {
      console.error(error);
    }
  }

  broadcastUpdate() {
    const membertype = this.app.currentUser.type;
    this.memberFilterCopy = { ...this.memberFilter };

    if (membertype == "Manager") {
      this.managerCoachView = false;
      // this could be used to get coach permission on the front end, restriction for this case
      // has been handled on the backend that's why i commented this out
      // this.memberFilter.coachTeam= this.coachService.getManagerCoachPermissions();
    } else {
      this.managerCoachView = true;
    }

    Object.keys(this.memberFilterCopy).forEach((item) => {
      if (
        Array.isArray(this.memberFilterCopy[item]) &&
        this.memberFilterCopy[item].includes("noData")
      ) {
        this.handleClearSelection(item.toString());
        this.memberFilter[item] = ["noData"];
        this.memberFilterCopy[item] = ["noData"];
      }
    });

    this.memberFilterData$.emit(this.memberFilterCopy);
    this.onMemberFilterUpdate.emit(this.memberFilterCopy);
    this.onFilterLoadingChange(true);
  }

  async loadFilterOptions() {
    // const raceSelections =
    //   this.store.getState().entities.dashboard.profileSelections["race"];
    // const genderSelections =
    //   this.store.getState().entities.dashboard.profileSelections["gender"];
    // const sexualOrientationSelections =
    //   this.store.getState().entities.dashboard.profileSelections[
    //   "sexualOrientation"
    //   ];
    const noData = {
      value: 'noData',
      label: 'No Data',
    }
    const genders = await this.adminService.getGenderSelections().toPromise();
    const racesEnthicity = await this.adminService.getRacesSelections().toPromise();
    const sexualOrientation = await this.adminService.getSexualOrientationSelections().toPromise();
    // Get statuses
    this.filterOptions.status$ = this.getStatusOptions().pipe(
      map((status) => {
        return [{ value: 'all', label: 'All' }, ...status.map((val) => {
          return {
            value: val.value,
            label: val.label,
          };
        }), noData]
      })
    );


    // Get partners
    this.filterOptions.partner$ = this.partnerService.getPartners().pipe(
      map((partners) => {
        return [{ value: 'all', label: 'All' }, ...partners.map((val) => {
          return {
            value: val._id,
            label: val.name,
          };
        }), noData]
      })
    );

    this.filterOptions.engagementStatusOptions =
      [...this.engagementStatusOptions.map((val) => {
        return {
          value: val.value,
          label: val.displayTitle,
        };
      })];

    // Get shit time and shift days
    this.filterOptions.shiftTime = [{ value: 'all', label: 'All' }, ...this.shiftTimes, noData];
    this.filterOptions.shiftDay = [{ value: 'all', label: 'All' }, ...this.shiftDays, noData];

    // TODO: Get wellness survey groups from member profile
    this.filterOptions.wellnessSurveyGroup = [{ value: 'all', label: 'All' }, ...this.WellnessSurveyData, noData];

    // Get race/ethnicity

    

    // Get gender
    this.filterOptions.gender = [
      { value: 'all', label: 'All' },
      ...Object.keys(genders.genderSelections).map((key) => {
        return ({ value: key, label: genders.genderSelections[key] });
      }),
      noData
    ];

    this.filterOptions.raceAndEthnicity = [
      { value: 'all', label: 'All' },
      ...Object.keys(racesEnthicity.racesSelections).map((key) => {
        return ({ value: key, label: racesEnthicity.racesSelections[key] });
      }),
      noData
    ];


    this.filterOptions.orientation = [
      { value: 'all', label: 'All' },
      ...Object.keys(sexualOrientation.sexualOrientationSelections).map((key) => {
        return ({ value: key, label: sexualOrientation.sexualOrientationSelections[key] });
      }),
      noData
    ];


    /// Get coach teams
    this.filterOptions.coachTeam = [
      { value: 'all', label: 'All' },
      ...Object.entries(this.memberFilterOptions.coachTeam).map(([name, [id]]) => ({ value: id, label: name })),
      noData
    ];

    // Get city options
    this.filterOptions.city = [{ value: 'all', label: 'All' }, ...this.memberFilterOptions.city.map((item) => {
      return {
        value: item,
        label: item,
      };
    }), noData];
    this.filterOptions.leadSource$ = this.leadService.getLeadSource().pipe(
      map((source) => {
        return source.map(item => {
          return {
            value: item._id,
            label: item.value
          }
        })
      })
    )
    // Get wellness survey Group
    this.filterOptions.wellnessSurveyGroup = [{ value: 'all', label: 'All' }, ...this.WellnessSurveyData, noData];
    this.filterOptions.ages = [{ value: 'all', label: 'All' }, ...getMemberAgeRange()];
    this.filterOptions.lastActivity = [...getLastActivities().map(item => {
      return {
        value: item.id,
        label: item.name
      }
    }), noData]
  }

  getStatusOptions = () => {
    return this.studentService.getStatusesOptions().pipe(
      map((statuses) => {
        const options = statuses.map((s) => s.status);
        // const inactiveStatusIndex = options.indexOf("INACTIVE");
        // options.splice(inactiveStatusIndex + 1, 0, "EXITED");
        return options.map((option) => {
          return {
            value: option,
            label: option,
          };
        });
      })
    );
  };

  getCityOptions = () => {
    return this.coachService.getAssignedStudents().pipe(
      map((students) => {
        const options = students.map((s) => s.city);
        return Array.from(new Set(options)).map((option) => {
          return {
            value: option,
            label: option,
          };
        });
      })
    );
  };

  clearDateHelperButtonState() {
    this.dateHelperButtonState = {
      '1d': false,
      '7d': false,
      'start of school year': false
    };
  }

  onSelectShowFilter() {
    if (this.filterOptions.show === 'custom-range') {
      const startDate = moment().startOf('day');
      const endDate = moment().endOf('day');

      this.endMinDate = startDate.format();
      this.startMaxDate = endDate.format();

      this.filterOptions['startDate'] = startDate.format();
      this.filterOptions['endDate'] = endDate.format();
    } else {
      this.filterOptions.startDate = null
      this.filterOptions.endDate = null
    }

    this.broadcastUpdate();
  }

  onDateInputChange(whichDate: 'startDate' | 'endDate', momentDate: moment.Moment, doNotClearButtonState?) {
    if (!doNotClearButtonState) {
      this.clearDateHelperButtonState();
    }
    if (whichDate === 'startDate') {
      momentDate = momentDate.startOf('day');
      this.memberFilter['startDate'] = momentDate.format();
      this.memberFilter['endDate'] = this.memberFilter['endDate'] || moment().endOf('day').format();
      this.endMinDate = momentDate.toDate();
    } else if (whichDate === 'endDate') {
      momentDate = momentDate.endOf('day');
      this.memberFilter['endDate'] = momentDate.format();
      this.startMaxDate = momentDate.toDate();
    } else {
      this.memberFilter.startDate = null
      this.memberFilter.endDate = null
    }
  }
   
  clearFilter() {
    for (let filterOption in this.memberFilter) {
      if (this.memberFilter.hasOwnProperty(filterOption)) {
        this.memberFilter[filterOption] = "";
      }
    }
    this.broadcastUpdate();
  }

  untoggleAllSelection(item) {
    switch (item) {
      case "status":
        this.statusSelectedAll = false;
        this.statusFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "shiftTime":
        this.shiftTimeSelectedAll = false;
        this.shiftTimeFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      default:
        break;
      case "partner":
        this.partnerSelectedAll = false;
        this.partnerFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "coachTeam":
        this.coachTeamSelectedAll = false;
        this.coachTeamFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "shiftDay":
        this.shiftDaySelectedAll = false;
        this.shiftDayFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "wellnessSurveyGroup":
        this.wellnessSurveyGroupSelectedAll = false;
        this.wellnessSurveyGroupFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        this.wellnessSurveyGroupsNoData = true;
        break;
      case "raceAndEthnicity":
        this.raceAndEthnicitySelectedAll = false;
        this.raceAndEthnicityFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "orientation":
        this.orientationSelectedAll = false;
        this.orientationFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "gender":
        this.genderSelectedAll = false;
        this.genderFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "city":
        this.citySelectedAll = false;
        this.cityFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "ages":
        this.agesSelectedAll = false;
        this.agesFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "engagementStatus":
        this.engagementStatusFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        });
        break;
      case "leadSource":
        this.leadSourceSelectedAll = false;
        this.leadSourceFilter.options.forEach((item: MatOption) => {
          if (item.value !== "0") return item.deselect();
          return item.select();
        })
        break;

    }
  }

  toggleAllSelection(item) {
    switch (item) {
      case "status":
        this.statusSelectedAll = !this.statusSelectedAll;

        if (this.statusSelectedAll) {
          this.statusFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.statusFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "partner":
        this.partnerSelectedAll = !this.partnerSelectedAll;

        if (this.partnerSelectedAll) {
          this.partnerFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.partnerFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "coachTeam":
        this.coachTeamSelectedAll = !this.coachTeamSelectedAll;

        if (this.coachTeamSelectedAll) {
          this.coachTeamFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.coachTeamFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "shiftTime":
        this.shiftTimeSelectedAll = !this.shiftTimeSelectedAll;

        if (this.shiftTimeSelectedAll) {
          this.shiftTimeFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.shiftTimeFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "shiftDay":
        this.shiftDaySelectedAll = !this.shiftDaySelectedAll;

        if (this.shiftDaySelectedAll) {
          this.shiftDayFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.shiftDayFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "wellnessSurveyGroup":
        this.wellnessSurveyGroupSelectedAll =
          !this.wellnessSurveyGroupSelectedAll;
        this.wellnessSurveyGroupsNoData = false;
        if (this.wellnessSurveyGroupSelectedAll) {
          this.wellnessSurveyGroupFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.wellnessSurveyGroupFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "raceAndEthnicity":
        this.raceAndEthnicitySelectedAll = !this.raceAndEthnicitySelectedAll;

        if (this.raceAndEthnicitySelectedAll) {
          this.raceAndEthnicityFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.raceAndEthnicityFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "orientation":
        this.orientationSelectedAll = !this.orientationSelectedAll;

        if (this.orientationSelectedAll) {
          this.orientationFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.orientationFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "gender":
        this.genderSelectedAll = !this.genderSelectedAll;

        if (this.genderSelectedAll) {
          this.genderFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.genderFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "city":
        this.citySelectedAll = !this.citySelectedAll;

        if (this.citySelectedAll) {
          this.cityFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.cityFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "ages":
        this.agesSelectedAll = !this.agesSelectedAll;

        if (this.agesSelectedAll) {
          this.agesFilter.options.forEach((item: MatOption) => {
            return item.select();
          });
        } else {
          this.agesFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          });
        }
        break;
      case "leadSource":
        this.leadSourceSelectedAll = !this.leadSourceSelectedAll;
        if (this.leadSourceSelectedAll) {
          this.leadSourceFilter.options.forEach((item: MatOption) => {
            return item.select();
          })
        } else {
          this.leadSourceFilter.options.forEach((item: MatOption) => {
            return item.deselect();
          })
        }
        break;

      default:
        break;
    }
  }
  async handleAddSelections(items, type) {
    
    
    if (items.value === 'all' && type === 'status') {
      this.memberFilter.status = await this.filterOptions.status$.toPromise().then(response => {
        return response.map(item => item.value)
      })
    }
    if (items.value === 'all' && type === 'partner') {
      this.memberFilter.partner = await this.filterOptions.partner$.toPromise().then(response => {
        return response.map(item => item.value)
      })
    }
    if (items.value === 'all' && type === 'coachTeam') {
      this.memberFilter.coachTeam = this.filterOptions.coachTeam.map(item => item.value);
    }
    if (items.value === 'all' && type === 'shiftTime') {
      this.memberFilter.shiftTime = this.filterOptions.shiftTime.map(item => item.value);
    }
    if (items.value === 'all' && type === 'shiftDay') {
      this.memberFilter.shiftDay = this.filterOptions.shiftDay.map(item => item.value);
    }
    if (items.value === 'all' && type === 'wellnessSurveyGroup') {
      this.memberFilter.wellnessSurveyGroup = this.filterOptions.wellnessSurveyGroup.map(item => item.value);
    }
    if (items.value === 'all' && type === 'raceAndEthnicity') {
      this.memberFilter.raceAndEthnicity = this.filterOptions.raceAndEthnicity.map(item => item.value);
    }
    if (items.value === 'all' && type === 'gender') {
      this.memberFilter.gender = this.filterOptions.gender.map(item => item.value);
    }
    if (items.value === 'all' && type === 'orientation') {
      this.memberFilter.orientation = this.filterOptions.orientation.map(item => item.value);
    }
    if (items.value === 'all' && type === 'city') {
      this.memberFilter.city = this.filterOptions.city.map(item => item.value);
    }
    if (items.value === 'all' && type === 'ages') {
      this.memberFilter.ages = this.filterOptions.ages.map(item => item.value);
    }
    if (items.value === 'all' && type === 'engagementStatus') {
      this.memberFilter.engagementStatus = this.filterOptions.engagementStatusOptions.map(item => item.value);
    }
    if (items.value === 'all' && type === 'lastActivity') {
      this.memberFilter.lastActivity = this.filterOptions.lastActivity.map(item => item.value);
    }

  }

  handleRemoveSelection(items, type) {
    if (items.value.value === 'all') {
      this.handleClearSelection(type);
    } else {
      if (type === 'status') {
        this.memberFilter.status = this.memberFilter.status.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'partner') {
        this.memberFilter.partner = this.memberFilter.partner.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'coachTeam') {
        this.memberFilter.coachTeam = this.memberFilter.coachTeam.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'shiftTime') {
        this.memberFilter.shiftTime = this.memberFilter.shiftTime.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'shiftDay') {
        this.memberFilter.shiftDay = this.memberFilter.shiftDay.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'wellnessSurveyGroup') {
        this.memberFilter.wellnessSurveyGroup = this.memberFilter.wellnessSurveyGroup.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'raceAndEthnicity') {
        this.memberFilter.raceAndEthnicity = this.memberFilter.raceAndEthnicity.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'gender') {
        this.memberFilter.gender = this.memberFilter.gender.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'orientation') {
        this.memberFilter.orientation = this.memberFilter.orientation.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'city') {
        this.memberFilter.city = this.memberFilter.city.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'ages') {
        this.memberFilter.ages = this.memberFilter.ages.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'engagementStatus') {
        this.memberFilter.engagementStatus = this.memberFilter.engagementStatus.filter(item => item !== items.value && item !== 'all');
      }
      if (type === 'lastActivity') {
        this.memberFilter.lastActivity = this.memberFilter.lastActivity.filter(item => item !== items.value && item !== 'all');
      }
    }
  }
  handleClearSelection(type) {
    if (type === 'status') {
      this.memberFilter.status = [];
    }
    if (type === 'partner') {
      this.memberFilter.partner = []
    }
    if (type === 'coachTeam') {
      this.memberFilter.coachTeam = []
    }
    if (type === 'shiftTime') {
      this.memberFilter.shiftTime = []
    }
    if (type === 'shiftDay') {
      this.memberFilter.shiftDay = []
    }
    if (type === 'wellnessSurveyGroup') {
      this.memberFilter.wellnessSurveyGroup = []
    }
    if (type === 'raceAndEthnicity') {
      this.memberFilter.raceAndEthnicity = []
    }
    if (type === 'gender') {
      this.memberFilter.gender = []
    }
    if (type === 'orientation') {
      this.memberFilter.orientation = []
    }
    if (type === 'city') {
      this.memberFilter.city = []
    }
    if (type === 'ages') {
      this.memberFilter.ages = []
    }
    if (type === 'engagementStatus') {
      this.memberFilter.engagementStatus = []
    }
    if (type === 'lastActivity') {
      this.memberFilter.lastActivity = []
    }
  }
  async handleAdvanceSelection(event, type) {

  }
  onFilterLoadingChange(isLoading: boolean) {
    this.onFilterLoading.emit(isLoading);
  }
  handleDateRange(type, event) {
    const selectedDate = event.target.value;
    const currentDate = new Date();
    const selectedDateObj = new Date(selectedDate);

    // Prevent future dates
    if (selectedDateObj > currentDate) {
      console.error('Error: Future date selected');
      return;
    }

    if (type === 'startDate') {
      // Check if endDate exists and is before the selected startDate
      if (this.memberFilter['endDate'] && selectedDateObj > new Date(this.memberFilter['endDate'])) {
        this.notification.toastr.error("Start date cannot be greater than end date")
        return;
      }
      this.memberFilter['startDate'] = moment(selectedDate).format('YYYY-MM-DD'); // already in YYYY-MM-DD format from input[type="date"]
    } else if (type === 'endDate') {
      // Check if startDate exists and is after the selected endDate
      if (this.memberFilter['startDate'] && new Date(this.memberFilter['startDate']) > selectedDateObj) {
        this.notification.toastr.error('Error: End date cannot be earlier than start date');
        return;
      }
      this.memberFilter['endDate'] = moment(selectedDate).format('YYYY-MM-DD');
    }
  }
  ngOnDestroy() {
    this.clearFilter();
  }
}
